/*
 * fn: toArray
 *
 * Converts a single value to an array, or returns as an array if it is already an array
 *
 */
export const toArray = <T>(value: T | T[]) => (Array.isArray(value) ? value : [value])
